<template>
  <div class="tw-flex tw-flex-wrap tw-gap-2">
    <template v-if="invoice">
      <a v-if="invoice.pdfUrl" :href="invoice.pdfUrl" target="_blank" rel="noopener">
        <WdsTag gray sm>
          {{ formattedNumber }}
        </WdsTag>
      </a>
      <WdsTag v-else gray sm>
        {{ formattedNumber }}
      </WdsTag>
    </template>
    <WdsText v-else size="sm">-</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestInvoiceColumn = graphql(`
  fragment PaymentRequestInvoiceColumn on PaymentRequest {
    id
    invoice {
      id
      number
      pdfUrl
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestInvoiceColumn>
}>()

const column = computed(() => useFragment(PaymentRequestInvoiceColumn, props.row))

const invoice = computed(() => column.value.invoice || null)

const formattedNumber = computed(() => {
  const number = invoice.value?.number

  if (!number) {
    return '-'
  }

  return number.startsWith('#') ? number : `#${number}`
})
</script>
